module.exports = __webpack_public_path__ + "img/truck-remove.b8fc8275.svg";